<template>
	<div class="popup" v-cloak v-if="linkTaskShow">
		<div class="content" id="linkTaskBox">
			<div class="title">
				{{$t('language.popup.remoteTaskPopup.addLinkTask')}}
				<div class="icon white-close dialog-close" @click="destory()"></div>
			</div>
			<div class="link-task-content">
				<div class="link-task">
					<textarea :placeholder="this.$t('language.popup.remoteTaskPopup.urlLinkSupported')" v-model="textLink"></textarea>
					<div class="error-prompt">
						<span v-show="emptyLink" v-if="uploadWeb || uploadMagnet">
							{{$t('language.popup.remoteTaskPopup.validLink')}}</span>
						<!-- <div v-show="!emptyLink">
							<div class="link-name-title">
								 <div v-show="editShow && uploadWeb" style="padding-top: 3px;">
									<span ref="OldName" @click="editName()" class="task-link-name" :title="linkNameFull" @mouseenter="hoverCurrent=1"
									 @mouseleave="hoverCurrent=-1">
										<span class="link-name-span"> {{linkName}} </span><span ref="linkNameSuffx" style="display:none;">...</span>
										<div class="icon-util edit-small edit-linkName-position" v-show="hoverCurrent==1 && textLink"></div>
									</span>
									<span class="link-name-outclass" ref="listInputName" @mouseover.stop="hoverCurrent=-1" @click.stop="">
										<input class="list-task-edit" v-model="linkNameFull" @blur="sumitName()" />
										<span class="task-edit-icon">
											<i class="icon-util name-sure link-icon-position" @click.stop='sumitName()'></i>
											<i class="icon-util name-cancel link-icon-position" @mousedown.stop='cancelEdit()'></i>
										</span>
									</span>
								</div>
							</div>
						</div> -->
					</div>
					<div class="select-cloud" :class=selectCloudClass @click="selectCloudOpen()" :title="cloudCatalog">
						<span v-if="!cloudCatalog">{{cloudPlaceholder}}</span>
						<span v-if="cloudCatalog">
							<div class="icon link-icon-position" v-bind:class="cloudType+'-small'"></div>
							{{cloudCatalog}}
						</span>
					</div>
					<div class="link-name-box">
						<transition>
							<div class="flow-sync-icon" v-show="flowShow" id='addOfflineFlow'>
								<div class="icon transfer-task-position cloudsync flow-sync-position"></div>
							</div>
						</transition>
						<div class="remoteLoading">
							<input type="file" hidden="hidden" id="torrent" accept=".torrent" @change="torrentShow()" />
							<button class="addTorrent" @click="addTorrent()">{{$t('language.popup.remoteTaskPopup.addTorrent')}}</button>
							<button v-loading='loading' class="saveCloud" @click="submitOffLine()">{{$t('language.popup.remoteTaskPopup.saveCloud')}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import commonUtils from "@/js/workspace/common_util.js";
	import editInput from '@/components/common/input/edit_input';
	import taskListUtils from "@/js/workspace/task_list_util.js";
	import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
  import requestUtils from '@/js/request_util.js';
	import taskOfflineUtils from '@/js/workspace/task_offline_util.js';
	export default {
		data: function() {
			return {
				flowShow: false,
				hoverCurrent: -1,
				linkTaskShow: false,
				selectCloudClass: '',
				cloudCatalog: null,
				cloudPlaceholder: this.$t('language.popup.taskListPopup.selectCloud'),
				cloudType: null,
				toDrivesInfo: null,
				textLink: null,
				emptyLink: false,
				emptyTorrent: false,
				linkName: null,
				linkNameFull: null,
				oldName: null,
				flowShow: false,
				editShow: false,
				loading: false,
				torrentFile: null,
				magnet: null,
				uploadWeb: true,
				uploadMagnet: false,
			}
		},
		watch: {
			linkName(newValue, oldValue) {
				if (newValue) {
					this.editShow = true;
				}
			},
			textLink(newValue, oldValue) {
				if (this.textLink) {
					this.uploadWeb = true;
					const torrent = this.getTorrentElement()
					torrent.value = null;
					this.torrentFile = null;
					this.uploadMagnet = false;
					if (this.vertifiWeb()) {
						this.emptyLink = false;
						let str = this.textLink;
						this.linkNameFull = this.catchLinkName(str);
						this.linkName = this.getShorthand(this.linkNameFull, 35);
						if (this.linkName.length < this.linkNameFull.length) {
							this.$refs.linkNameSuffx.style.display = null;
						} else if (this.$refs.linkNameSuffx) {
							this.$refs.linkNameSuffx.style.display = "none";
						}
					} else {
						if (this.vertifiMagnet()) {
							this.linkName = null;
							this.uploadWeb = false;
							this.uploadMagnet = true;
							this.magnet = this.textLink;
						}
					}
				} else {
					this.linkName = null;
					if (this.$refs.linkNameSuffx) {
						this.$refs.linkNameSuffx.style.display = "none";
					}
				}

			},
		},
		components: {
			"edit-input": editInput,
		},
		methods: {
			selectCloudOpen() {
				this.$parent.$refs.uploadToTreeDialog.uploadToShow = true;
				this.linkTaskShow = false;
			},
			vertifiWeb() {
				if (this.textLink) {
					const browsingItemLinkHttp = this.textLink.substr(0, 7).toLowerCase();
					const browsingItemLinkHttps = this.textLink.substr(0, 8).toLowerCase();
					// https、https
					if (browsingItemLinkHttp == "http://" || browsingItemLinkHttps == "https://") {
						return true;
					}
				}
				return false;
			},
			catchLinkName(str) {
				var index1 = str.lastIndexOf("\/");
				var index2 = str.lastIndexOf("?");
				if (index2 != -1) {
					if (index2 - index1 > 1) {
						str = str.substring(index1 + 1, index2);
					} else {
						let index3 = str.indexOf("\/\/");
						str = str.substring(index3 + 2, index2);
					}
				} else {
					let name = str.substring(index1 + 1, str.length);
					if (name == "" || name.trim() == "") {
						str = str.substring(0, index1);
						index1 = str.lastIndexOf("\/");
					}
					str = str.substring(index1 + 1, str.length);
				}
				return str;
			},
			destory() {
				this.textLink = null;
				this.linkName = null;
				this.torrentFile = null;
				var torrent = this.getTorrentElement();
				if (torrent != null) {
					torrent.files.FileList = [];
				}
				this.cloudCatalog = null;
				this.cloudType = null;
				this.uploadMagnet = false;
				this.uploadWeb = true;
				this.linkTaskShow = false;
				this.loading = false;
				this.hoverCurrent = -1;
				this.selectCloudClass = null;
				this.toDrivesInfo = null;
				this.emptyLink = false;
				this.emptyTorrent = false;
				this.oldName = null;
				this.flowShow = false;
				this.editShow = false;
				this.magnet = null;
			},
			vertifiMagnet() {
				if (this.textLink) {
					const browsingItemLinkMagnet = this.textLink.substr(0, 7).toLowerCase();
					if (browsingItemLinkMagnet == "magnet:") {
						this.emptyLink = false;
						return true;
					}
				}
				this.emptyLink = true;
				return false;
			},
			getTorrentElement() {
				return document.getElementById("torrent");
			},
			editName() {
				this.oldName = this.linkNameFull;
				let that = this;
				this.$refs.listInputName.style.display = "block";
				this.$refs.OldName.style.display = 'none';
				let endPoint = this.linkNameFull.lastIndexOf(".");
				let input = this.$refs.listInputName.children[0];
				input.focus();
				if (endPoint != -1) {
					input.setSelectionRange(0, endPoint);
				} else {
					input.select();
				}
			},
			cancelEdit() {
				this.linkNameFull = this.oldName;
				this.editInputStyle('none', 'block');
			},
			sumitName() {
				if (!this.linkName) {
					let str = this.catchLinkName(this.textLink);
					this.linkName = this.getShorthand(str, 35);
				} else {
					if (this.linkNameFull.trim().length == 0 && this.textLink) {
						this.cancelEdit();
					} else {
						this.editInputStyle('none', 'block');
						this.linkName = this.getShorthand(this.linkNameFull, 35);
					}
				}
				if (this.linkName.length < this.linkNameFull.length) {
					this.$refs.linkNameSuffx.style.display = null;
				} else {
					this.$refs.linkNameSuffx.style.display = "none";
				}
			},
			addTorrent() {
				if (!this.verifyCloud()) {
					this.showBannel(this.$t('language.popup.remoteTaskPopup.torrentStore'), "linkTaskBox");
				} else {
					const input = this.getTorrentElement();
					input.click();
				}
			},
			initTorrent() {
				//初始化 为保证监听器生效，uploadWeb和 uploadMagnet必须在textLink前执行
				this.uploadWeb = false;
				this.uploadMagnet = false;
				this.textLink = null;
			},
			torrentShow() {
				this.initTorrent()
				const input = this.getTorrentElement();
				this.torrentFile = input.files[0];
				var cloudSite = taskTransferUtils.createTransferToItems(this.toDrivesInfo);
				this.ifTorrent(cloudSite);
				this.destory();
			},
			getShorthand(str, limit) {
				var count = 0;
				for (var i = 0; i < str.length; i++) {
					const success = str[i].replace(/[\u0391-\uFFE5]/g, "aa");
					if (success == "aa") {
						count++;
					}
				}
				var realLen = str.length;
				if (realLen > limit) {
					return str.substr(0, limit);
				}
				return str;
			},
			editInputStyle(obj1, obj2) {
				let that = this;
				this.$refs.listInputName.style.display = obj1;
				this.$refs.OldName.style.display = obj2;
				this.$refs.listInputName.children[0].focus();
				this.$nextTick(function() {
					this.$refs.listInputName.children[0].select();
				});
			},
			submitOffLine() {
				// 防止多次点击
				if (this.loading) {
					return;
				}
        let that = this;
				var exsitSource = this.uploadWeb || this.uploadMagnet || this.torrentFile;
				if (!exsitSource) {
					this.$toast({
						text: this.$t('language.popup.remoteTaskPopup.emptySource'),
						type: 'fail',
						idValue: "linkTaskBox"
					});
					return;
				}
        var cloudSite = taskTransferUtils.createTransferToItems(this.toDrivesInfo);
        let drive = cloudSite[0];
        // 权限检查
        if(drive.driveType == 'google_drive_sharedWithMe' || drive.driveType == 'gSuiteSharedDrive'){
          let uploadData = {
              dd:drive.driveId,
              tid:drive.fileId,
              ud: commonUtils.getUser().id
           };
          this.loading = true;
          requestUtils.doFilesRequest("upload.createSession", uploadData ,{timeout:1800000}).then(result => {
            requestUtils.doFilesRequest(result.upload_id + "/upload_check", uploadData ,{timeout:1800000}).then(res => {
                if(res.status == 401){
                  that.$toast({
                      text: that.$t('language.exception.' + res.reason),
                      type: 'fail',
                      idValue: "linkTaskBox"
                  });
                  that.loading = false;
                }else{
                   that.doRequest(cloudSite);
                }
            });
          });
        }else{
          this.doRequest(cloudSite);
        }
			},
      doRequest(cloudSite){
        if (this.uploadWeb) {
        	if (!this.vertifiWeb()) {
        		this.showBannel(this.$t('language.popup.remoteTaskPopup.downloadLink'), "linkTaskBox");
        		return;
        	}
        	if (!this.verifyCloud()) {
        		this.showBannel(this.$t('language.popup.remoteTaskPopup.tip'), "linkTaskBox");
        		return;
        	}
			//判断是否是临时用户，然后提醒用户进行绑定邮箱
			let user = commonUtils.getUser();
			if (commonUtils.testUserIsTourist(user)) {
				this.$parent.$refs.remindBindEmailDialog.remindBindEmailShow = true;
				return false;
			}
        	this.loading = true;

        	this.ifWeb(cloudSite);
        }
        if (this.uploadMagnet) {
        	if (!this.vertifiMagnet()) {
        		this.showBannel(this.$t('language.popup.remoteTaskPopup.downloadLink'), "linkTaskBox");
        		return;
        	}
        	if (!this.verifyCloud()) {
        		this.showBannel(this.$t('language.popup.remoteTaskPopup.tip'), "linkTaskBox");
        		return;
        	}
			//判断是否是临时用户，然后提醒用户进行绑定邮箱
			let user = commonUtils.getUser();
			if (commonUtils.testUserIsTourist(user)) {
				this.$parent.$refs.remindBindEmailDialog.remindBindEmailShow = true;
				return false;
			}
        	this.loading = true;
        	this.ifMagnet(cloudSite);
        }
      },
			verifyCloud() {
				if (!this.cloudType || !this.cloudCatalog) {
					this.selectCloudClass = "box-link-shake";
					setTimeout(() => {
						this.selectCloudClass = "box-shakeOrigin";
					}, 150);
					return false;
				}
				return true;
			},
			// 解析URL
			ifWeb(cloudSite) {
				let that = this;
				let nameArr = [];
				var addOffData = new taskOfflineUtils.addOffLineTask(commonUtils.getUser().id, 3, this.linkNameFull.trim(),
					this.textLink.trim(), cloudSite);
				this.Utils.doTasksRequest("add", addOffData).then(res => {
					if (res.status == 200) {
						let itemData = res.tasks[0];
						if (that.$parent.offlineTaskData) {
							itemData.percent = "0.00";
							that.$parent.offlineTaskData.unshift(itemData);
							that.destory();
						} else {
							// 如果当前页面不是离线任务列表页面，执行动画效果。
							let that = this;
							this.initStoreCache(itemData, function() {
								that.exeCuteFlowIcon();
								setTimeout(function() {
									that.destory();
								}, 1500)
							});
						}
					} else {
						let text = null;
						if (res.reason == 'trafficNotEnough') {
							text = this.$t('language.popup.upgradeAccountPopup.insufficientTrafficDes');
						}
						if (res.reason == 'saltInvalid') {
							text = this.$t('language.exception.saltInvalid');
						}
						if (res.reason == 'taskMaximumNumberLimited') {
							text = this.$t('language.exception.remoteTask.maxLimit');
						}
						this.loading = false;
						this.$toast({
							text: text == null ? that.$t('language.exception.' + res.reason) : text,
							type: 'fail',
							idValue: "allBox"
						});
					}
				}, err => {
					that.loading = false;
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			// 解析磁力链接
			ifMagnet(cloudSites) {
				let that = this;
				let maxParseTime = 180 * 1000;
				let isParseFinished = false;
				var magnet = this.magnet.trim();
				let formData = new FormData();
				formData.append("magnet", magnet);
				formData.append("maxParseTime", maxParseTime);
				var request = "magnet/parse";
				let cloudSite = cloudSites[0];
				let magnetId = Math.random();
				that.$store.commit("setParseMagnet", "Running");
				this.$store.commit("setParseMagnetName", magnet);
				that.$store.commit("setCurrentParseMagnetId", magnetId);
				that.$store.commit("setParseMagnetCloudSite", cloudSite);
				this.Utils.doTorrentRequest(request, formData).then(res => {
					// 如果是云盘管理界面建立的任务
					if (this.isCloudExploer()) {
						// 解析超时转到离线界面的时间 ms
						let timeout = 1500;
						setTimeout(function() {
							if (!isParseFinished) {
								isParseFinished = true;
								that.exeCuteFlowIcon();
								setTimeout(function() {
									that.destory();
								}, 1500)
							}
						}, timeout)
						// 解析成功
						if (res.reason == "asyncParse") {
							// 如果在后台解析，则轮询结果到缓存
							this.getParseResult(maxParseTime, cloudSite, magnet);
						} else {
							isParseFinished = true;
							this.torrentResultHandler(res, cloudSite, magnet);
							this.destory();
						}
					}
					// 如果是离线任务界面建立的任务
					if (this.isRemoteUpload()) {
						this.$parent.$refs.parseTipsDialog.parseTipsShow = true;
						if (res.status == 400 && res.reason == "asyncParse") {
							this.getParseResult(maxParseTime, cloudSite, magnet);
						} else {
							this.torrentResultHandler(res, cloudSite, magnet);
						}
						this.destory();
					}
				}, err => {
					this.$store.commit("setParseMagnet", null);
					this.$store.commit("setParseMagnetName", null);
					if (this.$parent.$refs.parseTipsDialog) {
						this.$parent.$refs.parseTipsDialog.parseTipsShow = false;
					}
					this.loading = false;
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			// 解析种子文件
			ifTorrent(cloudSite) {
				let formData = new FormData();
				var file = this.torrentFile;
				formData.append("torrentFile", file);
				var request = "parse";
				this.$parent.$refs.parseTipsDialog.parseTipsShow = true;
				var that = this;
				let torrentName = this.torrentFile.name;
				this.Utils.doTorrentRequest(request, formData).then(res => {
					// 如果界面被切换，停止继续。
					if (!this.$parent.$refs.parseTipsDialog) {
						return;
					}
					this.torrentResultHandler(res, cloudSite[0], torrentName);
				}, err => {
					this.loading = false;
					if (this.$parent.$refs.parseTipsDialog) {
						this.$parent.$refs.parseTipsDialog.parseTipsShow = false;
					}
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			getParseResult(maxParseTime, cloudSite, magnet) {
				let that = this;
				let interval = 5 * 1000;
				let maxRollCount = maxParseTime / interval;
				let failObj = {
					"status": 400,
					"reason": "parseFail"
				}
				let formData = new FormData();
				formData.append("magnet", magnet);
				formData.append("maxParseTime", maxParseTime);
				// 定时器循环查询
				let asyncParseInterval = setInterval(function() {
					maxRollCount = maxRollCount - 1;
					// 如果解析被关闭了
					if (!that.$store.state.parseMagnet) {
						clearInterval(asyncParseInterval);
						return;
					}
					that.Utils.doTorrentRequest("magnet/parse/result", formData).then(res => {
						let result = null;
						if (res.status == 200) {
							that.$store.commit("setParseMagnet", res);
							clearInterval(asyncParseInterval);
							result = res;
						} else if (maxRollCount < 0 || (res.status == 400 && res.reason != "asyncParse")) {
							that.$store.commit("setParseMagnet", failObj);
							clearInterval(asyncParseInterval);
							result = failObj;
						}
						// 如果是在离线界面并已经解析出结果
						if (that.isRemoteUpload() && that.$parent.$refs.parseTipsDialog && result) {
							that.torrentResultHandler(result, cloudSite, magnet);
						}
					});
				}, interval);
			},
			isRemoteUpload() {
				if (this.$parent.offlineTaskData) {
					return true;
				}
				return false;
			},
			isCloudExploer() {
				if (this.$parent.tableData) {
					return true;
				}
				return false;
			},
			torrentResultHandler(res, cloudSite, name) {
				this.$parent.$refs.parseTipsDialog.parseTipsShow = false;
				if (res.status == 200) {
					this.$parent.$refs.subfileSelectDialog.initData(res.data);
					this.$parent.$refs.subfileSelectDialog.cloudSite = cloudSite;
					this.$parent.$refs.subfileSelectDialog.subfileShow = true;
				}
				if (res.status == 401) {
					this.showBannel(this.$t('language.exception.saltInvalid'), this.$parent.$refs.rightBo.id)
				}
				if (res.status == 400) {
					if (res.reason == "parseFail" || res.reason == "unsupportedTorrent") {
						this.showBannel(this.$t('language.popup.remoteTaskPopup.parseFail'), this.$parent.$refs.rightBo.id)
						this.saveFailedParse(cloudSite, name);
					}
				}
				// 清空磁力解析缓存
				this.$store.state.parseMagnet = null;
				this.$store.state.parseMagnetCloudSite = null;
			},
			// 记录解析失败的任务
			saveFailedParse(cloudSite, name) {
				let that = this;
				var requestData = new taskOfflineUtils.addParseFailedTask(commonUtils.getUser().id, 6, cloudSite, name);
				this.Utils.doTorrentRequest("parsefail", requestData).then(res => {
					let data = res.data;
					const task = {
						"filesize": 0,
						"result": data.state,
						"name": data.name,
						"id": data.id,
						"toItem": data.toItem,
						"type": data.type,
						"url": data.url
					};
					task.toItem.id = data.toItem.fileId;
					task.toItem.name = data.toItem.filename;
					if (res.status == 200 && that.$parent.offlineTaskData) {
						that.$parent.offlineTaskData.unshift(task);
					} else {
						this.initStoreCache(task, () => {
							that.updataLeftNum();
						});
					}
				}, err => {
					this.loading = false;
					if (this.$parent.$refs.parseTipsDialog) {
						this.$parent.$refs.parseTipsDialog.parseTipsShow = false;
					}
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			initStoreCache(itemData, callback) {
				let that = this;
				let offlineList = this.$store.state.remoteTaskArr;
				if (!offlineList) {
					this.initOfflineData(function(offlineData) {
						offlineList = offlineData;
						// offlineList.unshift(itemData);
						that.$store.commit("setRemoteTaskArr", offlineList);
						callback();
					})
				} else {
					offlineList.unshift(itemData);
					this.$store.commit("setRemoteTaskArr", offlineList);
					callback();
				}
			},
			initOfflineData(callback) {
				var that = this;
				var list = [];
				var offLineData = new taskListUtils.taskListData(commonUtils.getUser().id, 3);
				this.Utils.doTasksRequest("list", offLineData).then(res => {
					if (res.status == 200) {
						var offlineTasks = res.tasks;
						offlineTasks.sort(function(a, b) {
						  return -(a.createTime - b.createTime)
						});
						callback(offlineTasks);
					} else {
						this.loading = false;
						that.$toast({
							text: res.reason,
							type: 'fail',
							idValue: "allBox"
						});
					}
				}, err => {
					this.loading = false;
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			showBannel(reason, idValue) {
				this.$toast({
					text: reason,
					type: 'fail',
					idValue: idValue
				});
			},
			exeCuteFlowIcon() {
				let that = this;
				that.flowShow = true;
				this.$nextTick(function() {
					that.flowTransferIcon();
				});
				this.updataLeftNum();
			},
			updataLeftNum() {
				var mc_project = this.$parent.$parent;
				let dom;
				$.each(mc_project.$children, function(i, item) {
					if (item.menuOptions) { //如果是left_banner组件
						dom = mc_project.$children[i];
						return;
					}
				});
				dom.taskListNumber = dom.taskListNumber + 1;
				setTimeout(() => {
					let taskRedMark = document.getElementById("listRedMark5");
					taskRedMark.style.display = 'block';
				}, 1300);
			},
			flowTransferIcon() {
				let flowIcon = document.getElementById("addOfflineFlow");
				let taskListIcon = document.getElementById("menuOption5");
				//获取传输图标应该移动的距离并设置样式
				let xPx = taskListIcon.getBoundingClientRect().left - flowIcon.getBoundingClientRect().left;
				let yPx = taskListIcon.getBoundingClientRect().bottom - flowIcon.getBoundingClientRect().bottom;
				flowIcon.style.transition = 'all 1.4s ease';
				flowIcon.style.transform = 'translate3d(' + xPx + 'px, ' + yPx + 'px, 0px) scale(1.2) scale(1)';
				setTimeout(() => {
					flowIcon.style.transition = 'none';
					flowIcon.style.transform = 'translateX(1px)';
					flowIcon.style.opacit = '0';
				}, 1500);
			},
		},
	}
</script>

<style>
	.task-link-name {
		color: #4281ff;
		height: 40px;
		/*no*/
	}

	.link-name-outclass {
		display: none;
		width: 240px;
		/*no*/
		height: 28px;
		/*no*/
		border: 1px solid #8a96e3;
		/*no*/
		position: relative;
		float: left;
		margin-left: 5px;
		/*no*/
	}

	.edit-linkName-position {
		position: relative;
		left: 3px;
		/*no*/
		float: left;
		top: 5px;
		/*no*/
	}

	#linkTaskBox .el-loading-spinner .circular {
		height: 0.25rem !important;
		width: 0.25rem !important;
	}

	#linkTaskBox {
		width: 680px;
		/*no*/
		height: 458px;
		/*no*/
	}

	.link-task-content {
		width: 680px;
		/*no*/
		height: 460px;
		/*no*/
		box-sizing: border-box;
		padding: 20px;
		/*no*/
	}

	.link-task {
		width: 640px;
		/*no*/
		height: 260px;
		/*no*/
	}

	.link-task textarea {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 15px 10px 0px 15px;
		/*no*/
		border: 1px solid #d4edfa;
		/*no*/
		font-size: 14px;
		/*no*/
		/*no*/
		font-family: Arial, "Microsoft YaHei", 微软雅黑;
		resize: none;
		color: #6f7886;
	}

	.link-task textarea::-webkit-input-placeholder {
		color: #ccc;
	}

	.link-task textarea:focus {
		border: 1px solid #8a96e3;
		/*no*/
		outline: none;
	}

	.select-cloud:hover {
		width: 100%;
		height: 32px;
		/*no*/
		border: 1px solid #8a96e3;
		/*no*/
		line-height: 30px;
		/*no*/
		color: #6f7886;
		font-size: 14px;
		/*no*/
		box-sizing: border-box;
		padding: 0 10px;
		/*no*/
		cursor: pointer;
	}

	.select-cloud {
		width: 640Px;
		/*no*/
		height: 32px;
		/*no*/
		border: 1px solid #d4edfa;
		/*no*/
		line-height: 30px;
		/*no*/
		color: #6f7886;
		font-size: 14px;
		/*no*/
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		padding: 0px 10px;
		/*no*/
		margin-top: 3px;
		/*no*/
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.link-task-button {
		float: right;
	}

	.link-name-box {
		width: 100%;
		height: 30px;
		/*no*/
		margin-top: 8px;
		/*no*/
	}

	.saveCloud {
		position: absolute;
		right: 18px;
	}

	.addTorrent {
		background-color: white;
		border: 0.5px solid #5166BD;
		color: #5166BD;
	}

	.addTorrent:hover {
		cursor: pointer;
		background-color: #EDF2FC;
		border: 0.5px solid #5166BD;
		color: #5166BD;
	}

	.link-tips {
		width: 100%;
		height: 8px;
		margin-bottom: 2px;
		font-size: 7px;
		color: #ff1b46;
		color: red;

	}

	.remoteLoading {
		margin-top: 20px;
	}

	#linkTaskBox .el-loading-spinner .path {
		stroke: #FFFFFF !important;
	}

	#linkTaskBox .el-loading-spinner {
		padding-top: 13.5px !important;
	}

	#linkTaskBox .el-loading-mask {
		background-color: rgba(81, 102, 189, 2) !important;
		z-index: 10 !important;
	}



	.error-prompt {
		font-size: 14px;
		/*no*/
		color: #ff1b46;
		width: 100%;
		height: 30px;
		/*no*/
		line-height: 30px;
		/*no*/
	}

	.link-icon-position {
		position: relative;
		top: 2px;
		/*no*/
	}

	.link-name-title {
		width: 100%;
		height: 14px;
	}

	.link-name-span {
		font-size: 14px;
		/*no*/
		max-width: 620px;
		/*no*/
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.link-name-span:hover {
		text-decoration: underline;
		cursor: pointer;
	}

	.link-icon-position {
		position: relative;
		top: 4px;
		/*no*/
	}
</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/add_link_task_popup.vue